import { useMemo } from 'react';
import { ApolloClient, NormalizedCacheObject } from 'apollo-boost';
import { createApolloClient } from './client';
import { IncomingHttpHeaders } from 'http';

let apolloClient: ApolloClient<NormalizedCacheObject>;

function isSSR() {
    return typeof window === 'undefined';
}

export function initializeApollo(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    initialState: any = null,
    headers?: IncomingHttpHeaders
) {
    const _apolloClient =
        apolloClient ?? createApolloClient(initialState, headers);

    // If your page has Next.js data fetching methods that use Apollo Client,
    // the initial state gets hydrated here
    if (initialState) {
        // Get existing cache, loaded during client side data fetching
        const existingCache = _apolloClient.extract();

        // Restore the cache using the data passed from
        // getStaticProps/getServerSideProps combined with the existing cached data
        _apolloClient.cache.restore({ ...existingCache, ...initialState });
    }

    if (isSSR()) return _apolloClient;

    // Create the Apollo Client once in the client
    if (!apolloClient) apolloClient = _apolloClient;
    return _apolloClient;
}

export function useApollo(initialState: Record<string, unknown>) {
    const store = useMemo(() => initializeApollo(initialState), [initialState]);
    return store;
}
